<template>
  <el-dialog
    title="编辑角色"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="角色名称" prop="name">
        <el-input 
          v-model="form.name" 
          placeholder="必填，请填写角色名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="角色描述" prop="description">
        <el-input
          type="textarea"
          v-model="form.description"
          placeholder="选填，请填写角色描述"
          :rows="3"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <div v-if="errorInfo" class="error-message">{{errorInfo}}</div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updatePrivilegeGroup } from '@/api/frame/roleApi'

export default {
  name: 'EditPrivilegeGroup',
  data() {
    return {
      dialogVisible: false,
      form: {
        pgId: '',
        name: '',
        description: ''
      },
      rules: {
        name: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' },
          { min: 2, max: 10, message: '角色名称长度必须在2位至10位', trigger: 'blur' }
        ],
        description: [
          { max: 200, message: '角色描述长度不能超过200位', trigger: 'blur' }
        ]
      },
      errorInfo: ''
    }
  },
  methods: {
    open(role) {
      this.form = {
        pgId: role.pgId,
        name: role.name,
        description: role.description
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.errorInfo = ''
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        try {
          const res = await updatePrivilegeGroup(this.form)
          if (res.code === 0) {
            this.$message.success('修改成功')
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.errorInfo = res.msg
          }
        } catch (error) {
          console.error('修改角色失败:', error)
          this.errorInfo = '修改角色失败'
        }
      })
    }
  }
}
</script>

<style scoped>
.error-message {
  color: #f56c6c;
  margin-bottom: 15px;
}
</style>